import { InsertDriveFile } from "@mui/icons-material";
import ArticleIcon from "@mui/icons-material/Article";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import GasMeterOutlinedIcon from "@mui/icons-material/GasMeterOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import InsightsIcon from "@mui/icons-material/Insights";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import MonitorOutlinedIcon from "@mui/icons-material/MonitorOutlined";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import PeopleIcon from "@mui/icons-material/People";
import RecentActorsOutlinedIcon from "@mui/icons-material/RecentActorsOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Table, Card } from "components/lynx-components";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { localizationService } from "services/localization-service";
import {
  hasAnyEventRole,
  hasAnyMonitoringRole,
  roleMatch,
} from "../../actions/auth";
import { UserRoles } from "../../types/enums";
export const MainSidebar = () => {
  const navigate = useNavigate();
  const organization = useSelector((state) => state.organization);
  const account = useSelector((state) => state.account);
  if (account.isLoading) {
    return <></>;
  }

  return (
    <aside className="sidebar" id="mainSidebar">
      <Card className=" h-100">
        <Table
          responsive
          highlightRowOnHover
          hasOutline
          verticalAlign="center"
          cards
          className="text-nowrap lynx-sidebar-table"
        >
          <Table.Body>
            <>
              <Table.Row
                className="pointer sidebar-dashboard"
                onClick={() => navigate("/dashboard")}
              >
                <Table.Col>
                  <MonitorOutlinedIcon
                    fontSize="small"
                    sx={{ color: "#495057" }}
                  />
                </Table.Col>
                <Table.Col>
                  {localizationService.getLocalizedString(
                    "dashboard.dashboard"
                  )}
                </Table.Col>
              </Table.Row>

              <Table.Row
                className="pointer sidebar-map"
                onClick={() => navigate("/map")}
              >
                <Table.Col>
                  <MapOutlinedIcon fontSize="small" sx={{ color: "#495057" }} />
                </Table.Col>
                <Table.Col>
                  {localizationService.getLocalizedString("map.map")}
                </Table.Col>
              </Table.Row>

              {roleMatch([UserRoles.Admin]) && (
                <Table.Row
                  className="pointer sidebar-assets"
                  onClick={() => navigate("/assets")}
                >
                  <Table.Col>
                    <HomeOutlinedIcon
                      fontSize="small"
                      sx={{ color: "#495057" }}
                    />
                  </Table.Col>
                  <Table.Col>
                    {localizationService.getLocalizedString("assets.assets")}
                  </Table.Col>
                </Table.Row>
              )}
            </>

            {hasAnyEventRole() && (
              <Table.Row
                className="pointer sidebar-events"
                onClick={() => navigate("/events")}
              >
                <Table.Col>
                  <EventOutlinedIcon
                    fontSize="small"
                    sx={{ color: "#495057" }}
                  />
                </Table.Col>
                <Table.Col>
                  {localizationService.getLocalizedString("events.events")}
                </Table.Col>
              </Table.Row>
            )}
            {hasAnyEventRole() && organization.hasCommitments && (
              <Table.Row
                className="pointer sidebar-volunteers"
                onClick={() => navigate("/commitments")}
              >
                <Table.Col>
                  <HandshakeOutlinedIcon
                    fontSize="small"
                    sx={{ color: "#495057" }}
                  />
                </Table.Col>
                <Table.Col>
                  {localizationService.getLocalizedString(
                    "commitments.commitments"
                  )}
                </Table.Col>
              </Table.Row>
            )}
            {roleMatch([UserRoles.InspectionsUser]) && (
              <Table.Row
                className="pointer sidebar-inspections"
                onClick={() => navigate("/inspections")}
              >
                <Table.Col>
                  <ContentPasteIcon
                    fontSize="small"
                    sx={{ color: "#495057" }}
                  />
                </Table.Col>
                <Table.Col>
                  {localizationService.getLocalizedString(
                    "inspections.inspections"
                  )}
                </Table.Col>
              </Table.Row>
            )}
            {roleMatch([UserRoles.IncidentsUser]) && (
              <Table.Row
                className="pointer sidebar-incidents"
                onClick={() => navigate("/incidents")}
              >
                <Table.Col>
                  <WarningAmberIcon
                    fontSize="small"
                    sx={{ color: "#495057" }}
                  />
                </Table.Col>
                <Table.Col>
                  {localizationService.getLocalizedString(
                    "incidents.incidents"
                  )}
                </Table.Col>
              </Table.Row>
            )}
            {(hasAnyEventRole() || roleMatch([UserRoles.IncidentsUser])) && (
              <Table.Row
                className="pointer sidebar-actions"
                onClick={() => navigate("/actions")}
              >
                <Table.Col>
                  <PendingActionsIcon
                    fontSize="small"
                    sx={{ color: "#495057" }}
                  />
                </Table.Col>
                <Table.Col>
                  {localizationService.getLocalizedString("actions.actions")}
                </Table.Col>
              </Table.Row>
            )}
            {hasAnyEventRole() && organization.hasTraining && (
              <Table.Row
                className="pointer sidebar-training"
                onClick={() => navigate("/training")}
              >
                <Table.Col>
                  <SchoolOutlinedIcon
                    fontSize="small"
                    sx={{ color: "#495057" }}
                  />
                </Table.Col>
                <Table.Col>
                  {localizationService.getLocalizedString("training.training")}
                </Table.Col>
              </Table.Row>
            )}
            {hasAnyMonitoringRole() && (
              <Table.Row
                className="pointer sidebar-monitoring"
                onClick={() => navigate("/monitoring")}
                id="monitoringSidebarRow"
              >
                <Table.Col>
                  <GasMeterOutlinedIcon
                    fontSize="small"
                    sx={{ color: "#495057" }}
                  />
                </Table.Col>
                <Table.Col>
                  {localizationService.getLocalizedString(
                    "monitoring.monitoring"
                  )}
                </Table.Col>
              </Table.Row>
            )}
            {organization.hasPermitFeature && (
              <Table.Row
                className="pointer sidebar-permits"
                onClick={() => navigate("/permits")}
              >
                <Table.Col>
                  <ArticleIcon fontSize="small" sx={{ color: "#495057" }} />
                </Table.Col>
                <Table.Col>
                  {localizationService.getLocalizedString("permits.permits")}
                </Table.Col>
              </Table.Row>
            )}
            {organization.featureFlags.showInDevelopmentFeatures && (
              <Table.Row
                className="pointer"
                onClick={() => navigate("/portal-submissions")}
              >
                <Table.Col>
                  <PeopleIcon fontSize="small" sx={{ color: "#495057" }} />
                </Table.Col>
                <Table.Col>
                  {localizationService.getLocalizedString(
                    "screen.sidebar.communityPortal1"
                  )}
                  <br></br>
                  {localizationService.getLocalizedString(
                    "screen.sidebar.communityPortal2"
                  )}
                </Table.Col>
              </Table.Row>
            )}
            {roleMatch([UserRoles.InspectionsUser]) && (
              <Table.Row
                className="pointer sidebar-equipment"
                onClick={() => navigate("/equipment")}
              >
                <Table.Col>
                  <ConstructionOutlinedIcon
                    fontSize="small"
                    sx={{ color: "#495057" }}
                  />
                </Table.Col>
                <Table.Col>
                  {localizationService.getLocalizedString(
                    "equipment.equipment"
                  )}
                </Table.Col>
              </Table.Row>
            )}

            <>
              <>
                <Table.Row
                  className="pointer"
                  onClick={() => navigate("/kpis")}
                >
                  <Table.Col>
                    <InsightsIcon fontSize="small" sx={{ color: "#495057" }} />
                  </Table.Col>
                  <Table.Col>
                    {localizationService.getLocalizedString("kpis.kpis")}
                  </Table.Col>
                </Table.Row>
              </>
              {hasAnyEventRole() && (
                <Table.Row
                  className="pointer"
                  onClick={() => navigate("/contacts")}
                >
                  <Table.Col>
                    <RecentActorsOutlinedIcon
                      fontSize="small"
                      sx={{ color: "#495057" }}
                    />
                  </Table.Col>
                  <Table.Col>
                    {localizationService.getLocalizedString(
                      "contacts.contacts"
                    )}
                  </Table.Col>
                </Table.Row>
              )}
            </>

            <Table.Row
              className="pointer sidebar-documents"
              onClick={() => navigate("/documents")}
              style={{ borderBottom: "1px solid #ced4da" }}
            >
              <Table.Col>
                <InsertDriveFile fontSize="small" sx={{ color: "#495057" }} />
              </Table.Col>
              <Table.Col>
                {localizationService.getLocalizedString("documents.documents")}
              </Table.Col>
            </Table.Row>

            <Table.Row
              className="pointer sidebar-settings"
              onClick={() => navigate("/settings")}
              style={{ borderBottom: "1px solid #ced4da" }}
            >
              <Table.Col>
                <SettingsOutlinedIcon
                  fontSize="small"
                  sx={{ color: "#495057" }}
                />
              </Table.Col>
              <Table.Col>
                {localizationService.getLocalizedString("settings.settings")}
              </Table.Col>
            </Table.Row>
          </Table.Body>
        </Table>
      </Card>
    </aside>
  );
};
